export const PRIORITY_CITIES = ['Tirana', 'Durrës', 'Vlorë', 'Elbasan'];

export const ALBANIAN_CITIES = [
  'Belsh',
  'Berat',
  'Bulqizë',
  'Cërrik',
  'Delvinë',
  'Devoll',
  'Dibër',
  'Divjakë',
  'Dropull',
  'Durrës',
  'Elbasan',
  'Fier',
  'Finiq',
  'Fushë-Arrëz',
  'Gjirokastër',
  'Gramsh',
  'Has',
  'Himarë',
  'Kamëz',
  'Kavajë',
  'Kelcyrë',
  'Klos',
  'Kolonjë',
  'Konispol',
  'Korçë',
  'Krastë',
  'Krujë',
  'Kuçovë',
  'Kukës',
  'Kurbin',
  'Lezhë',
  'Libohovë',
  'Librazhd',
  'Lushnjë',
  'Malësi e Madhe',
  'Mallakastër',
  'Mat',
  'Memaliaj',
  'Mirditë',
  'Patos',
  'Peqin',
  'Përmet',
  'Pogradec',
  'Poliçan',
  'Prrenjas',
  'Pukë',
  'Pustec',
  'Roskovec',
  'Rrogozhinë',
  'Sarandë',
  'Selenicë',
  'Shkodër',
  'Skrapar',
  'Tepelenë',
  'Tirana',
  'Tropojë',
  'Vau i Dejës',
  'Vlorë',
  'Vorë',
];

export const getAlbanianCityOptions = () => {
  const prioritySet = new Set(PRIORITY_CITIES);
  const rest = ALBANIAN_CITIES
    .filter((city) => !prioritySet.has(city))
    .sort((a, b) => a.localeCompare(b, 'sq'));

  return [...PRIORITY_CITIES, ...rest];
};

export const parsePropertyCity = (location) => {
  if (!location) return '';

  const cityPart = location.split(',')[0].trim();
  const options = getAlbanianCityOptions();
  const exactMatch = options.find(
    (city) => city.toLowerCase() === cityPart.toLowerCase()
  );

  if (exactMatch) return exactMatch;

  const partialMatch = options.find(
    (city) => cityPart.toLowerCase().includes(city.toLowerCase())
      || city.toLowerCase().includes(cityPart.toLowerCase())
  );

  return partialMatch || cityPart;
};

export const isKnownAlbanianCity = (city) =>
  getAlbanianCityOptions().includes(city);
